"use client";

import { createSVGIcon } from "@faire/slate/lib/iconUtils";
import React from "react";

// TODO(alipianu): keep in sync with Figma (synced from https://www.figma.com/design/qcB5qVN7uKBBYHN49ihDE7/Slate-Icons?node-id=9321-716&m=dev)
/** @optimized using svgo:^3.0.2 */
export const Clover = createSVGIcon(
  <g clipPath="url(#clip0_9321_715)" fill="currentColor">
    <path d="M11.214 5.607A5.61 5.61 0 0 0 5.606 0 5.605 5.605 0 0 0 0 5.604a5.61 5.61 0 0 0 5.607 5.61h5.607zM12.786 5.607A5.61 5.61 0 0 1 18.394 0 5.605 5.605 0 0 1 24 5.604a5.61 5.61 0 0 1-5.607 5.61h-5.607zM12.786 18.393a5.607 5.607 0 1 0 5.607-5.607h-5.607zM11.214 18.393a5.607 5.607 0 1 1-5.607-5.607h5.607zM5.605 22.42a4.034 4.034 0 0 0 4.036-4.024V14.36H5.61a4.045 4.045 0 0 0-4.038 4.035 4.033 4.033 0 0 0 4.032 4.024" />
  </g>,
  "Clover",
  (strictLocalize) => ({
    viewBox: "0 0 24 24",
    fill: "none",
    color: "#228800",
    titleAccess: strictLocalize({
      id: "Du66ys",
      defaultMessage: "Clover logo",
      description: { text: "The label for Clover's company logo icon" },
    }),
  })
);
